import { http, HttpResponse } from 'msw'

export const mockCreateCustomerAdditionalContact = http.post(
  '/my-business/api/agency/v1/customers/:customerId/additional-contacts',
  () => {
    return HttpResponse.json(
      { timestamp: new Date().toISOString() },
      { status: 201 },
    )
  },
)
